__turbopack_context__.v({
  "container": "RGiO-W_container",
  "size--sm": "RGiO-W_size--sm",
});
